import { Flex } from 'antd'
import Image from '@/components/image'
import imageAdvantage1 from '@/assets/img/solution/disaster-relief/advantage-1.png'
import imageAdvantage2 from '@/assets/img/solution/disaster-relief/advantage-2.png'
import imageAdvantage3 from '@/assets/img/solution/disaster-relief/advantage-3.png'
import imageAdvantage4 from '@/assets/img/solution/disaster-relief/advantage-4.png'
import imageAdvantage5 from '@/assets/img/solution/disaster-relief/advantage-5.png'
import Styles from './style.module.scss'

const TITLE = 'Why Carus'
const data = [
  {
    image: imageAdvantage1,
    title: 'Rapid Deployment',
    description:
      'Pre-engineered mobile cabinets and containerized ESS,ready to operate on arrival. Supports both off-grid and grid-connected modes',
  },
  {
    image: imageAdvantage2,
    title: 'High Reliability',
    description:
      'Liquid-cooled batteries with cabinet-level and system-level fire protection, ensuring safe operation in high-risk environments',
  },
  {
    image: imageAdvantage3,
    title: 'Smart Monitoring',
    description: 'Intelligent EMS for remote visibility, predictive alerts, and fault prevention',
  },
  {
    image: imageAdvantage4,
    title: 'Multi-Purpose Station',
    description: 'Storage + charging backup power for clinics, shelters, communications, and reconstruction sites',
  },
  {
    image: imageAdvantage5,
    title: 'Storm-Resistant PV',
    description:
      'Integrated solar roof tiles tested to withstand winds up to 107 mph, ideal for disaster-prone regions.',
  },
]

export default function Advantage() {
  return (
    <div className={Styles.advantage}>
      <h2>{TITLE}</h2>
      <Flex className={Styles.content}>
        {data.map((item, index) => (
          <Flex vertical align='center' key={index} className={Styles.item}>
            <Image src={item.image} alt={item.title} rootClassName={Styles.image} />
            <div className={Styles.title}>{item.title}</div>
            <div className={Styles.description}>{item.description}</div>
          </Flex>
        ))}
      </Flex>
    </div>
  )
}
